import _extends from "@babel/runtime-corejs3/helpers/extends";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import PropTypes from 'prop-types';
import React from 'react';
import { isEmpty } from 'lodash';
import { SelectField } from '@unite-us/ui';
import replaceAndCapitalizeString from '../../utils/replaceAndCapitalizeString';
var EnumSelect = function EnumSelect(props) {
  var enums = props.enums,
    inline = props.inline;
  if (isEmpty(enums)) {
    return null;
  }
  var options = _mapInstanceProperty(enums).call(enums, function () {
    var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return {
      value: option.value,
      label: replaceAndCapitalizeString(option.display_name)
    };
  });
  return /*#__PURE__*/React.createElement(SelectField, _extends({}, props, {
    options: options,
    inline: inline
  }));
};
EnumSelect.propTypes = {
  enums: PropTypes.array,
  id: PropTypes.string.isRequired,
  inline: PropTypes.bool,
  label: PropTypes.string
};
EnumSelect.defaultProps = {
  enums: [],
  inline: false,
  label: ''
};
export default EnumSelect;
//# sourceMappingURL=index.js.map